export default {
  isActive: "Active",
  notActive: "Not Active",
  b2b: "B2B",
  b2c: "B2C",
  underValue: (value: string) => `Under ${value}`,
  betweenValues: (min: string, max: string) => `${min} to ${max}`,
  aboveValue: (value: string) => `${value} +`,
};
